const sanitizeFilterOption = (option) => {
	if (typeof option === 'string') {
		const dot = option.replaceAll('.', '-dot-');
		const underscore = dot.replaceAll('_', '-underscore-');
		return underscore;
	} else {
		return option;
	}
};

const addNamesToOptionItems = (data) => {
	return data.map((filterOption) => ({
		...filterOption,
		items: filterOption.items.map((item) => ({
			...item,
			name: `${sanitizeFilterOption(
				filterOption.type
			)}_${sanitizeFilterOption(
				filterOption.value
			)}_${sanitizeFilterOption(item.value)}`,
			children: item.children?.map((child) => ({
				...child,
				name: `custom_ajtonyilas-underscore-child_${sanitizeFilterOption(
					child.value
				)}`,
			})),
		})),
	}));
};

const mergeFilterArrays = (a, b) => {
	return b.reduce(
		(a, e1) =>
			a.find((e2) => e2.type === e1.type && e2.value === e1.value)
				? a
				: [...a, e1],
		a
	);
};

export default (endpoint, startingOpts, startingData) => ({
	isMobileFilterOpen: false,
	neverLoaded: true,
	isLoading: 0,
	sort: 'price-asc',
	defaultOrderSelected: true, //price-asc is default
	filterOpts: startingOpts,
	hasAnyFilterSelected: false,
	data: {
		category: startingData?.category,
		filters: addNamesToOptionItems(startingData?.leftSideFilters) || [],
		popularFilters: [],
		mainFilters: startingData.mainFilters,
		products: startingData?.products || [],
		pagination: {
			countPages: startingData?.pagination?.countPages || 0,
			countItems: startingData?.pagination?.countItems || 0,
		},
	},



	filterShouldShow(filter) {
		const should =
			filter.items.reduce((a, e) => a || e.count > 0, false) &&
			!filter.hidden;
		return should;
	},



	updateFilter() {
		this.updateURL();
		this.hasAnyFilterSelected = Object.values(this.filterOpts).some((value) => value);
		this.request();
	},



	updateURL() {
		console.info('updateURL');
		console.info(this.filterOpts);

		const currentParams = new URL(window.location).searchParams;


		let url = new URL(
			window.location.protocol +
				'//' +
				window.location.host +
				window.location.pathname
		);
		const setFilters = this.setFilters();
		console.log('setFilters', setFilters);
		setFilters.forEach((key) => {
			url.searchParams.set(key, true);
		});

		const filterKeys = Object.keys(this.filterOpts);
		Array.from(currentParams.keys()).forEach((key) => {
			if(!filterKeys.includes(key)){
				url.searchParams.set(key, currentParams.get(key));
			}
		})

		const sortValues = this.sort.split('-');
		url.searchParams.set('order_by', sortValues[0]);
		url.searchParams.set('order_dir', sortValues[1]);


		window.history.pushState({}, '', url.pathname + url.search);

	},



	// hasAnyFilterSelected(){
	// 	return Object.values(this.filterOpts).some((x) => x);
	// },



	init() {
		this.filterOpts['width-filter'] = null;
		this.filterOpts['height-filter'] = null;
		this.filterOpts['depth-filter'] = null;

		this.updateInitialStateFromUrl();

		this.$watch('sort', () => {
			this.request();
			this.defaultOrderSelected = this.sort === 'price-asc';
		});


		this.hasAnyFilterSelected = Object.values(this.filterOpts).some((value) => value);
		this.request();
	},



	request() {
		this.updateURL();
		this.isLoading++;
		const queryString = `${endpoint}?${this.requestSorting()}&${this.requestFilters()}`;
		this.$dispatch('pokeshowmore');
		this.data.popularFilters = [];
		fetch(queryString, {
			method: 'GET',
			headers: { Accept: 'application/json' },
		}).then((resp) => {
			if (resp.ok) {
				resp.json().then((json) => {
					this.data.category = json.data.category;
					this.data.products = json.data.products;
					this.$nextTick(() => {
						this.data.popularFilters = addNamesToOptionItems(
							json.data.popularFilters
						);
					});
					this.data.pagination = json.data.pagination;
					this.data.filters = addNamesToOptionItems(
						json.data.leftSideFilters
					);
					this.isLoading--;
					console.log(json);
				});
			} else {
				this.isLoading--;
			}
		});
	},



	updateInitialStateFromUrl(){
		const params = new URL(document.location).searchParams;

		const order_by = params.get('order_by')
		const order_dir = params.get('order_dir')

		if(order_by && order_dir){
			this.sort = `${order_by}-${order_dir}`;
			this.defaultOrderSelected = this.sort === 'price-asc';
		}

		Array.from(params.keys()).forEach((key) => {
			const dimension = this.dimensions.find((dimension) => key.includes(dimension))
			console.log(dimension);
			if(dimension){
				this.filterOpts[`${dimension}-filter`] = key;
			}
		})
	},



	requestSorting() {
		const split = this.sort.split('-');
		const value = split[0];
		const dir = split[1];
		return `orderBy=${value}&orderDir=${dir}`;
	},



	setFilters() {
		console.log(this.filterOpts);


		this.sizeKeys.forEach((key) => this.filterOpts[key] = false);

		this.dimensions.forEach((dimension)=>{
			if(this.filterOpts[`${dimension}-filter`]){
				console.log(this.filterOpts[`${dimension}-filter`]);
				this.filterOpts[this.filterOpts[`${dimension}-filter`]] = true;
			}
		})

		return Object.entries(this.filterOpts)
			.filter(([_, value]) => value === true)
			.map(([key, _]) => key);
	},



	taglistItems() {
		const filterArray = this.data.filters;
		const popularFilterArray = this.data.popularFilters;
		const appliedFilters = [];
		const addToAppliedFiltersIfFiltered = (label, itemLabel, itemName) => {
			if (this.filterOpts[itemName]) {
				appliedFilters.push({
					typeName: label,
					valueName: itemLabel,
					filterOptName: itemName,
				});
			}
		};
		filterArray.forEach(({ items, label }) =>
			items.forEach((item) => {
				addToAppliedFiltersIfFiltered(label, item.label, item.name);
				item.children?.forEach((child) => {
					addToAppliedFiltersIfFiltered(
						item.label,
						child.label,
						child.name
					);
				});
			})
		);
		popularFilterArray
			.filter(({ type }) => type === 'popular')
			.forEach(({ items, label }) =>
				items.forEach((item) => {
					addToAppliedFiltersIfFiltered(label, item.label, item.name);
				})
			);
		return appliedFilters;
	},



	removeAllFilters() {
		Object.entries(this.filterOpts).forEach(([key, _]) => {
			this.filterOpts[key] = false;
		});
		this.$dispatch('filteroptionchange');
	},




	removeFilter(key){

		this.dimensions.forEach((dimension) => {
			if(key.includes(dimension)){
				this.filterOpts[dimension + '-filter'] = null;
			}
		});
		this.filterOpts[key] = false;

		this.$dispatch('filteroptionchange');
	},



	decomposeFilter(filter) {
		const arr = filter
			.split('_')
			.map((s) =>
				s.replaceAll('-dot-', '.').replaceAll('-underscore-', '_')
			);
		return arr.length !== 3
			? null
			: { type: arr[0], value: arr[1], itemValue: arr[2] };
	},



	gtm(data) {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push(data);
	},



	requestFilters() {
		const filters = this.setFilters()
			.map(this.decomposeFilter)
			.filter((x) => x !== null);

		const groupedFilters = {};
		filters.forEach(({ type, value, itemValue }) => {
			if (!groupedFilters[type]) {
				groupedFilters[type] = {};
			}
			if (!groupedFilters[type][value]) {
				groupedFilters[type][value] = [];
			}
			const len = groupedFilters[type][value].length;
			groupedFilters[type][value][len] = itemValue;
		});
		const filterText = Object.entries(groupedFilters)
			.map(([type, values]) =>
				Object.entries(values).map(([value, itemValues]) =>
					itemValues.map(
						(itemValue, i) =>
							`filters[${type}][${value}][${i}]=${itemValue}`
					)
				)
			)
			.flat(3);
		return filterText.join('&');
	},



	mainProps: {
		['@filteroptionchange.window'](value) {
			console.log('watch', value);
			this.updateFilter();
		},
	},


	get sizeKeys(){
		return Object.keys(this.filterOpts).filter((key) => {
			return key.includes('custom') && (
				key.includes('width') ||
				key.includes('height') ||
				key.includes('depth')
			);
		});
	},

	get dimensions(){
		return [
			'width',
			'height',
			'depth'
		]
	}
});
